module.exports = __webpack_public_path__ + "img/bullet-list-text-white.6124978a.svg";